/*
 * @fileOverView FeaturedCarousel component definition
 */

import Vue from 'vue';

// Store the jQuery instance from Drupal.
// Slick-Carousel will override it and the attached behaviors may not work.
window.drupalJQuery = window.jQuery;
// Dynamic import to avoid hoisting and restoring the Drupal jQuery instance.
import('slick-carousel').then(() =>  window.jQuery = window.drupalJQuery);

import Blazy from 'blazy';

/**
 * A reference to the selectors used in this view
 *
 * @property SELECTORS
 * @type {Object}
 * @private
 */
const SELECTORS = {
  'ARROW_NEXT': '.js-carouselNavigation-arrow_next',
  'ARROW_PREV': '.js-carouselNavigation-arrow_prev',
  'COUNT_CURRENT': '.js-carouselNavigation-count-current',
  'COUNT_TOTAL': '.js-carouselNavigation-count-total',
  'CAROUSEL': '.js-basicCarousel'
};

/**
 * [basicCarousel Vue]
 * @type {class}
 */
Vue.component('basic-carousel-vue', {
  props: {
    'isParentExpanded': {
      default: true,
      type: Boolean
    },
    "navigateToSlide": {
      default: 0,
      type: Number
    }
  },

  watch: {
    /**
     * Allows a parent, such as a modal, to delay initialization until opened.
     */
    isParentExpanded: function (val) {
      if (val) {
        this.initialize();
      }
    },

    navigateToSlide: function(val) {
      if (this.isInitialized && this.isParentExpanded) {
        this.itemCarousel.slick('slickGoTo', val);
        this.updateCounters();
      }
      else {
        this.intialSlide = val || 0;
      }
    }
  },

  mounted() {
    if (this.isParentExpanded) {
      this.initialize();
    }
  },

  methods: {
    /**
     * Initializes the component
     */
    initialize() {
      if (this.isInitialized) return;
      this.isInitialized = true;

      this.bLazy = new Blazy({
        container: SELECTORS.CAROUSEL,
        success: (ele) => {
          setTimeout(function(){
            ele.classList.add('loadComplete');
            }, 200);
          }
      });

      this.$items = $(this.$refs.items);

      // $items is just a easy reference inside deeper function scopes.
      const $items = this.$items;

      // When Carousels are hidden, oftentimes dimensions are not set correctly.
      // Hence, we use a ResizeObserver to refresh the SlickSlider whenever
      // its dimension changes (also triggered by hide/show functions).
      this.$items.on("init", function () {
        const resizeObserver = new ResizeObserver(() => {
          $items.slick("refresh");
        });
        resizeObserver.observe($items[0]);
      });

      this.itemCarousel = this.$items.slick({
        nextArrow: $(this.$el).find(SELECTORS.ARROW_NEXT),
        prevArrow: $(this.$el).find(SELECTORS.ARROW_PREV),
        infinite: false,
        speed: 500,
        initialSlide: this.initialSlide || 0
      });

      this.updateCounters();

      this.hideInactiveVideos();

      // Allows counter to stay in sync with main item slide changes.
      this.$items.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $(this.$el).find(SELECTORS.COUNT_CURRENT).text(nextSlide + 1);
        this.showNewlyActiveVideo(nextSlide);
        this.autoPauseVideos();
      });

      this.$items.on('afterChange', this.handleAfterChange);
    },

    /**
     * Handles updating content after the slide changes
     * @return {void} [description]
     */
    handleAfterChange() {
      this.hideInactiveVideos();

      this.$nextTick(() => {
        this.bLazy.revalidate();
      });
    },

    /**
     * Will update the counters
     * @return {void} [description]
     */
    updateCounters() {
      // Handling the counter (CURRENT/TOTAL).
      $(this.$el).find(SELECTORS.COUNT_CURRENT).text(this.itemCarousel[0].slick.currentSlide + 1);
      $(this.$el).find(SELECTORS.COUNT_TOTAL).text(this.itemCarousel[0].slick.slideCount);
    },

    /**
     * Prevents user from tabbing into video controls on inactive slides.
     *
     * @method hideInactiveVideos
     * @public
     */
    hideInactiveVideos() {
      const $videos = this.$items.find('.video');

      $videos.each(function () {
        const $video = $(this);

        if (!$video.parents('.slick-active').length) {
          $video.addClass('video_inactive');
        }
      });
    },

    /**
     * Re-enables visibility and tabbing into video controls on active slides.
     *
     * @method showNewlyActiveVideo
     * @param  {int} nextSlide - The integer of the next slide's index.
     */
    showNewlyActiveVideo(nextSlide) {
      this.$items.find(`[data-slick-index="${nextSlide}"]`).find('.video').removeClass('video_inactive');
    },

    /**
     * Checks for videos in the carousel and sets them to pause when they aren't visible.
     *
     * @method autoPauseVideos
     */
    autoPauseVideos() {
      if (typeof VidyardV4 !== 'undefined') {
        const players = VidyardV4.players;

        if (players) {
          players.map(player => {
            if ($(player.element).parents(this.$items).length) {
              player.pause();
            }
          });
        }
      }
    }
  }
});
